export const localeTypes = {
	EN: 'en',
	KR: 'kr',
};

export const locales = [
	{
		name: localeTypes.EN,
		label: 'English',
	},
	{
		name: localeTypes.KR,
		label: 'Korean',
	},
];
